<template>
    <div class="login-bottom">
        <div class="login-container">
            <form class="login-bottom__form" @submit.prevent="validateBeforeSubmit">
                <h2 class="heading-1 login-container__heading">Connectez-vous</h2>
                <p>
                    <strong>Abonnement institutionnel</strong>
                    <br>
                    Connectez-vous grâce à vos identifiants
                </p>
                <div class="form-group">
                    <input type="email" class="form-control form-control-lg" v-model="form.login" placeholder="Nom d'utilisateur" />
                    <span class="error" v-if="errors.login">{{ errors.login }}</span>
                </div>

                <div class="form-group">
                    <input type="password" class="form-control form-control-lg" v-model="form.password" placeholder="Mot de passe"/>
                    <span class="error" v-if="errors.password">{{ errors.password }}</span>
                </div>

                <div class="form-group login-actions">
                    <button type="submit" class="btn btn-dark btn-lg btn-block login-actions__btn">Se connecter</button>
                    <router-link class="login-actions__link" :to="{ path: '/user/reset' }">Mot de passe oublié ?</router-link>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            onSubmit: false,
            onSend: false,
            errors: [],
            form: {
                login: null,
                password: null,
            },
        }
    },
    computed: {
        ...mapState(['auth'])
    },
    methods: {
        ...mapActions([
            'setAuthFromApi',
            'setOnLoad'
        ]),
        async validateBeforeSubmit()
        {
            if(this.onSend) return

            this.errors = []

            if (!this.form.login) {
                this.errors['login'] = "Nom d'utilisateur requis"
            // } else if (!this.validEmail(this.form.email)) {
            //     this.errors['email'] = 'Valid email required'
            }

            if (!this.form.password) {
                this.errors['password'] = 'Mot de passe requis'
            }

            if (!this.errors.length) {
                this.submit();
            }
            this.onSend = false
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        submit() {
            this.onSubmit = true
            this.setOnLoad(true)

            this.setAuthFromApi(
                { 'email': this.form.login, 'password': this.form.password, }
            ).then(() => {
                this.onSend = true
                this.$cookies.set('token', this.auth.token)
                this.$api.postActivity({
                    token: this.auth.token,
                    category: 'connexion',
                    action: 'login',
                    label: 'User login'
                });
                this.$router.push({ path: '/' })
            }).catch(() => {
                this.setOnLoad(false)
                this.errors['login'] = 'Email ou mot de passe inconnue'
                this.onSubmit = false
                this.onSend = false
            })
        }
    },
    mounted() {
        // this.setAuthFromApi({email: 'umayr.narain@gmail.com', password: 'umayr'})
    }
}
</script>

<style lang="scss">
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

  .login-bottom {
        padding: 45px 0 42px;
        background-color: #f5f5f5;
    
        @include min($lg) {
            padding: 65px 0 120px;
        }

        .form-group {
            @include min($lg) {
                max-width: 341px;
            }
        }
            
        .btn {
            width: 100%;
            background: var(--unnamed-color-283861) 0% 0% no-repeat padding-box;
            background: $main 0% 0% no-repeat padding-box;
            border-radius: 20px;
            min-height: 40px;
            border: none;
            padding: 0 20px;
            font-size: 16px;
            font-weight: $medium;
            color: $white;

            @include min($lg) {
                width: auto;
            }
        }
    }

    .login-actions {
        padding-top: 10px;
        text-align: center;

        @include min($lg) {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: center;
            text-align: left;
        }

        &__btn {
            margin: 0 0 20px;

            @include min($lg) {
                margin: 0;
            }
        }

        &__link {
            font-family: $campaign;
            font-size: 10px;
        }
    }

</style>